function logAdditionalInfo() {
  return process.env.ADDITIONAL_FRONTEND_LOGS === "TRUE"
}

const log = logAdditionalInfo()
  ? console.log.bind(console)
  : () => {
      // do nothing
    }

export default log
